module.exports = __webpack_public_path__ + "static/media/ic_remove_row.7ebf8d21.svg";